/**
 * Public site origin for canonical URLs, JSON-LD, and OG tags.
 * Set `REACT_APP_SITE_URL` in production (e.g. https://www.streetsaudio.com) to match your Vercel redirect.
 */
export function resolveSiteUrl(): string {
  const raw = process.env.REACT_APP_SITE_URL;
  if (raw && typeof raw === 'string') {
    const t = raw.trim().replace(/\/+$/, '');
    if (/^https?:\/\//i.test(t)) {
      return t;
    }
  }
  return 'https://streetsaudio.com';
}
